import React from 'react';
import { Box, Typography } from '@mui/material';
import { usePublicBrandContext } from '../../context/PublicBrandContext';
import { brandHeaderStyle, brandHeaderSx, resolvePublicBrand } from '../../utils/publicBrand';

/**
 * Shared header for public portal / pay / estimate / booking pages.
 * Uses PublicBrandShell context when `brand` prop is omitted.
 */
export default function PublicBrandHeader({ brand: brandProp, subtitle, compact, sticky }) {
  const ctx = usePublicBrandContext();
  const b = resolvePublicBrand(brandProp ?? ctx?.brand);

  return (
    <Box
      data-brand-primary={b.primary_color}
      style={brandHeaderStyle(b)}
      sx={{
        ...brandHeaderSx(b),
        mb: sticky ? 0 : compact ? 2 : 3,
        borderRadius: sticky ? 0 : 2,
        overflow: 'hidden',
        px: { xs: 2, sm: 3 },
        py: compact ? 1.5 : 2.5,
        boxShadow: sticky ? '0 4px 20px rgba(0,0,0,0.18)' : '0 4px 20px rgba(0,0,0,0.12)',
        ...(sticky
          ? {
              position: 'sticky',
              top: 0,
              zIndex: 1100,
            }
          : {}),
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {b.logo_url ? (
          <Box
            component="img"
            src={b.logo_url}
            alt={b.company_name}
            sx={{
              height: compact ? 36 : 44,
              maxWidth: 160,
              objectFit: 'contain',
              bgcolor: 'rgba(255,255,255,0.95)',
              borderRadius: 1,
              p: 0.5,
            }}
            onError={(e) => {
              e.currentTarget.style.display = 'none';
            }}
          />
        ) : null}
        <Box>
          <Typography variant={compact ? 'subtitle1' : 'h5'} sx={{ fontWeight: 900, lineHeight: 1.2 }}>
            {b.company_name}
          </Typography>
          {subtitle ? (
            <Typography variant="body2" sx={{ opacity: 0.92, mt: 0.25 }}>
              {subtitle}
            </Typography>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
}
